module.exports = __webpack_public_path__ + "img/16-Crown Platin.jpg";